import { render } from "./StudySettingsModal.vue?vue&type=template&id=033424e5&scoped=true"
import script from "./StudySettingsModal.vue?vue&type=script&lang=js"
export * from "./StudySettingsModal.vue?vue&type=script&lang=js"

import "./StudySettingsModal.vue?vue&type=style&index=0&id=033424e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033424e5"]])

export default __exports__